import React from "react";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import InputComponent from "../../UI/InputComponent/InputComponent";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import Dropdown from "../../UI/Dropdown/Dropdown";
import ReviserDataReviserView from "./ReviserDataReviserView";
import "./ReviserData.css";
const ReviserData = (props) => {
  const reviserData = props.parentState.newFormData.reviserRegistration.find(
    (element) => element.id == props.id
  );

  let dropDownData = props.parentState.newFormData.dropDownData.map(
    (element) => (
      <option key={element.id} value={element.id}>
        {element.value}
      </option>
    )
  );

  return (
    <div className="form-group">
      <Row>
        <Col>
          <Dropdown
            style={
              (props.required || reviserData.dataFetched) &&
              props.parentState.error &&
              reviserData.funkcija === '' &&
              "red"
            }
            label={props.required || reviserData.dataFetched ? "Funkcija*" : "Funkcija"}
            hidden
            id={`vrsta-revizora-dropdown${props.id}`}
            onChange={props.dropdownHandler}
            value={reviserData.funkcija}
            asProperty="select"
            map={dropDownData}
            text="Odaberite funkciju"
            readOnly = {!reviserData.dataFetched}
          />
        </Col>
        <Col>
          {reviserData.vrVeze != 3 ? (
            <>
              <InputComponent
                style={
                  props.required &&
                  props.parentState.error &&
                  reviserData.oibIdBrojDrustva.length < 1 &&
                  "red"
                }
                minLength={11}
                maxLength={
                  ((reviserData.vrVeze == 1 || reviserData.vrVeze == 2) &&
                    11) ||
                  "false"
                }
                objData={{ id: props.id, group: "reviserRegistration" }}
                onChange={props.mappedUserInputHandler}
                id={`oib-id-br-drustva${props.id}`}
                name="oibIdBrojDrustva"
                value={reviserData.oibIdBrojDrustva}
                controlLabel={
                  reviserData.vrVeze == 4
                    ? props.required
                      ? "OIB/Identifikator*"
                      : "OIB/Identifikator"
                    : props.required
                    ? "OIB*"
                    : "OIB"
                }
                // ne može se popunjavati polje dok se ne izabere vrsta revizora
                //disabled = {!reviserData.vrVeze ? true : false}
              />
            </>
          ) : (
            <InputComponent
              style={
                props.required &&
                props.parentState.error &&
                reviserData.oibIdBrojDrustva.length < 1 &&
                "red"
              }
              objData={{ id: props.id, group: "reviserRegistration" }}
              onChange={props.mappedUserInputHandler}
              id={`oib-id-br-drustva${props.id}`}
              name="oibIdBrojDrustva"
              value={reviserData.oibIdBrojDrustva}
              controlLabel={props.required ? "Identifikator*" : "Identifikator"}
            />
          )}
        </Col>

        <div className="mybutton">
          <ButtonComponent
            // disabled={disableButton}
            id={`fetch${props.id}`}
            onClick={props.getUserData}
            // ne može se dohvaćati dok se ne izabere vrsta revizora
            //disabled = {!reviserData.vrVeze ? true : false}
          >
            Dohvati
          </ButtonComponent>
        </div>
      </Row>

      <ReviserDataReviserView
        {...props}
        reviserData={reviserData}
        selectedDropdownValue={reviserData.vrVeze}
      />
    </div>
  );
};

export default ReviserData;
